import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import ReactToggle from "react-toggle"; 
import 'react-toggle/style.css';  
import * as Yup from "yup"
import { Col, Row } from "reactstrap"
import {
  
  Fn_DisplayData,
  Fn_FillListData,
   
} from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useLocation } from "react-router-dom"
 

function AddEdit_RateTableMaster() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/CourseMasterH"
  const API_URL_SAVE = API_WEB_URLS.BASE +"CompanyMaster/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/CompanyMaster/Id"

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  })
   
  const dispatch = useDispatch()
  const location = useLocation()
   
  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0")

    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  useEffect(() => {
    console.log(state.FillArray)
  }, [state.FillArray])

  const validationSchema = Yup.object({
    Rate : Yup.string().required("Rate is required"),
    Options : Yup.string().required("Options is required"),
    IsActive: Yup.boolean().required("Active status is required") 
    
  })
  
  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    console.log(values);
    let formData = new FormData();
    formData.append("Rate", values.Name);
    formData.append("Options", values.Description);
    formData.append("IsActive", values.IsActive );
    formData.append("UserId", obj.uid);
  };
 

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          IsActive: state.formData.IsActive || false,  
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({  setFieldValue, values }) => (
          <Form className="form-horizontal">
          <Row>
   

              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Rate
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage
                  name="Name"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>

            <Row>
   
      <Col lg='6' className="mb-3">
        <label htmlFor="Options" className="form-label">Options</label>
        <Field
          className="form-control"
          as="select"
          name="Options"
        >
          <option value="">Select</option>
          <option value="Disounts">Discounts</option>
          <option value="Custom Pricing">Custom Pricing</option>
        
        </Field>
        <ErrorMessage name="Options" component="div" className="text-danger" />
      </Col>
    </Row>

            <Row>
                <Col lg='1' className='mb-3'>
                  <label htmlFor='IsActive' className='form-label'>
                    Active
                  </label>
                </Col>
                <Col lg='2'>
                  <ReactToggle
                    checked={values.IsActive}
                    onChange={() => setFieldValue('IsActive', !values.IsActive)}
                  />
                  <ErrorMessage name='IsActive' component='div' className='text-danger' />
                </Col>
              </Row>
           
            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddEdit_RateTableMaster
